import { z } from "zod";

import { zRes401 } from "./common";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(
  200,
  z.object({
    firstOrderDate: z.string().datetime().nullable(),
  }),
);

const zRes = Response.Schema.zAggregated([zRes200, zRes401]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
